// React
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// Utils
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";

// Redux
import { Provider } from "react-redux";
import store from "./store";
import { setCurrentUser, logoutUser } from "./actions/authActions";

// Component
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import PrivateRoute from "./components/private-route/PrivateRoute";
import NotFound from "./components/404/404";
import Layout from "./components/layout/Layout";
import Workflow from "./components/workflow/Workflow";
import Datasheet from "./components/datasheet/Datasheet";
import Fixpunkt from "./components/workflow/av/fixpunkt/Fixpunkt";
import Manhole from "./components/workflow/abw/manhole/Manhole";

// Style
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.scss";

// Check for token to keep user logged in
if (localStorage.jwtToken) {
  // Set auth token header auth
  const token = localStorage.jwtToken;
  setAuthToken(token);
  // Decode token and get user info and exp
  const decoded = jwt_decode(token);
  // Set user and isAuthenticated
  store.dispatch(setCurrentUser(decoded));

// Check for expired token
  const currentTime = Date.now() / 1000; // to get in milliseconds
  if (decoded.exp < currentTime) {
    // Logout user
    store.dispatch(logoutUser());

    // Redirect to login
    window.location.href = "./";
  }
}

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
		  
		    <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/register" component={Register} />
			  <Route exact path="/fixpunkt/:id" component={Fixpunkt} />
			  <Route exact path="/manhole/:schema/:id" component={Manhole} />
              <PrivateRoute exact path="/dashboard" component={Layout} />
			  <PrivateRoute exact path="/map" component={Layout} />
			  <PrivateRoute exact path="/table" component={Layout} />
			  <PrivateRoute exact path="/workflow/:category/:object/:db_schema/:id" component={Workflow} />
			  <PrivateRoute exact path="/datasheet/:category/:object/:db_schema/:id" component={Datasheet} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;